import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KatExportPdfAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetKatiAtikRapor";
        super(baseUrl);
    }
    geExportPdfListe(sqId: string) {

        //var request = new ExportPdfListeRequest(sqId);
        let enRequest: IKatiAtikRequest = {
            sqId: sqId,
        };
        return this.post("", enRequest, true);
    }
}
export default new KatExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    constructor(sicilKodu: string) {

        this.sqId = sicilKodu;
    }
}

interface IKatiAtikRequest {
    sqId: string;
}
export { ExportPdfListeRequest };